import AxiosInstance from '../../core/api/axiosinstance'
import { querystring, promiseToResult } from '../../utils'

const getTranslate = () => {
  const query = { limit: 100000 }
  return promiseToResult(AxiosInstance().get(
    `/application/translations?${query ? querystring.stringify(query) : ''}&v=1.0003`,
    {
      headers: {
        'Cache-Control': 'max-age=604800',
      },
    },
  ))
}

export const TranslateAPI = {
  getTranslate,
}
